import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

export const getLeagueSectionSkeletonStyles = (theme: Theme) =>
  StyleSheet.create({
    card: {
      backgroundColor: theme.gray[100],
      borderRadius: 12,
      marginBottom: 16,
      overflow: 'hidden',
    },
    header: {
      paddingHorizontal: 14,
      paddingVertical: 10,
      borderBottomWidth: 1,
      borderBottomColor: theme.gray[200],
    },
    headerShimmer: {
      width: 140,
      height: 16,
      borderRadius: 4,
    },
    row: {
      paddingVertical: 10,
      paddingHorizontal: 12,
      flexDirection: 'row',
      alignItems: 'center',
      gap: 8,
      borderBottomWidth: 1,
      borderBottomColor: theme.gray[100],
    },
    rowTime: {
      width: 36,
      height: 12,
      borderRadius: 4,
    },
    rowScore: {
      width: 48,
      height: 14,
      borderRadius: 4,
    },
  });
